module.exports = __webpack_public_path__ + "static/img/jb_pic2.8deb50c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jb_pic2.jpg
// module id = PoRY
// module chunks = 4